import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../Config'; 
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import '../../Assets/Css/Profile.css';
import ProfilePicture from '../../Assets/Images/SVG/ProfilePic.svg';
import Editpen from '../../Assets/Images/SVG/Editpen.svg';

const Profile = () => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);

      const token = sessionStorage.getItem('authToken'); // Retrieve token from sessionStorage
      const patientid = sessionStorage.getItem('patientid'); // Retrieve patientid from sessionStorage
      if (!token || !patientid) {
        setError('No authentication token or patient ID found. Please log in.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${config.API_BASE_URL}/patient/profile/${patientid}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch profile: ${response.statusText}`);
        }

        const data = await response.json();

        // Ensure all the necessary data is set properly
        setProfileData(data.data);  // Assuming the API returns profile data in `data.data`
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleEditClick = () => {
    navigate('/profile-edit');
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="profile-container">
      <Header />
      <div className="profile-content">
        <div className="profile-header">
          <img
            src={profileData?.profile_image || ProfilePicture}
            alt="Profile"
            className="profile-picture"
          />
          <div className="pedit-icon" onClick={handleEditClick} style={{ cursor: 'pointer' }}>
            <img src={Editpen} alt="Edit" />
          </div>
        </div>

        <div className="profile-details">
          {/* Name and Gender Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Name</label>
              <input type="text" value={profileData?.name || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Gender</label>
              <input type="text" value={profileData?.gender || ''} readOnly />
            </div>
          </div>

          {/* Date of Birth and Contact Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Date of Birth</label>
              <input type="text" value={profileData?.dob || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Contact</label>
              <input type="text" value={profileData?.mobile_no || ''} readOnly />
            </div>
          </div>

          {/* Email Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Email ID</label>
              <input type="text" value={profileData?.mail || ''} readOnly />
            </div>
          </div>

          {/* Height and Weight Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Height (cms)</label>
              <input type="text" value={profileData?.height || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Weight (kg)</label>
              <input type="text" value={profileData?.weight || ''} readOnly />
            </div>
          </div>

          {/* Blood Group Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Blood Group</label>
              <input type="text" value={profileData?.blood_group || ''} readOnly />
            </div>
          </div>

          {/* Profile Image ID and Tenant ID Row */}
          <div className="profile-row">
            <div className="profile-field">
              <label>Profile Image ID</label>
              <input type="text" value={profileData?.profile_image_id || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Tenant ID</label>
              <input type="text" value={profileData?.tenant_id || ''} readOnly />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
